module.exports = __webpack_public_path__ + "img/dark-mud-decal-28.d2ba9f50.png";